<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { ListTodoIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .toggleTaskList()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="ListTodoIcon"
    shortcut="[]"
    @click="run"
    @keydown.enter="run"
  >
    Checklist
  </SuggestionListItem>
</template>
